import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';

import { AppSessionService } from './session/app-session.service';
import { AppUrlService } from './nav/app-url.service';
import { AppAuthService } from './auth/app-auth.service';
import { AppRouteGuard } from './auth/auth-route-guard';
import { LocalizePipe } from './pipes/localize.pipe';
import { FormattedFilenamePipe } from './pipes/formatted-filename.pipe';


// import { AbpPaginationControlsComponent } from './components/pagination/abp-pagination-controls.component';
// import { AbpValidationSummaryComponent } from './components/validation/abp-validation.summary.component';
// import { AbpModalHeaderComponent } from './components/modal/abp-modal-header.component';
// import { AbpModalFooterComponent } from './components/modal/abp-modal-footer.component';
// import { LayoutStoreService } from './layout/layout-store.service';

import { BusyDirective } from './directives/busy.directive';
import { EqualValidator } from './directives/equal-validator.directive';

@NgModule({
    imports: [
        CommonModule,
        NgxPaginationModule
    ],
    declarations: [
        // AbpPaginationControlsComponent,
        // AbpValidationSummaryComponent,
        // AbpModalHeaderComponent,
        // AbpModalFooterComponent,
        LocalizePipe,
        BusyDirective,
        EqualValidator
    ],
    exports: [
        // AbpPaginationControlsComponent,
        // AbpValidationSummaryComponent,
        // AbpModalHeaderComponent,
        // AbpModalFooterComponent,
        LocalizePipe,
        BusyDirective,
        EqualValidator
    ],
    providers: [
        AppSessionService,
        AppUrlService,
        AppAuthService,
        AppRouteGuard,
        // LayoutStoreService
    ]
})
export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: [
                AppSessionService,
                AppUrlService,
                AppAuthService,
                AppRouteGuard,
                // LayoutStoreService
            ]
        };
    }
}
